import { loadWishlists, saveWishlists } from "../transport/localStorage";
import { ensureDefaultWishlist } from "../lib/wishlistHelpers";
/**
 * Reactive variables store that mirrors the shape of webbridgeClient.variables
 * and emits the typed update events the SDK's WebbridgeProvider subscribes to.
 *
 * Important: setters REPLACE `this.variables` rather than mutating, because
 * the SDK pulls `webbridgeClient.variables` via getter on every event and
 * spreads it into reducer state — referential identity matters for downstream
 * React memoization.
 */
export class VariablesStore {
    constructor(events, config) {
        var _a, _b, _c;
        this.events = events;
        const customerId = (_b = (_a = config.customer) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
        const persisted = loadWishlists(config.appId, customerId);
        const wishlists = ensureDefaultWishlist(persisted);
        if (persisted.length === 0) {
            // First page load — persist the materialized default so the wishlist
            // ID is stable across this and subsequent sessions for this customer.
            saveWishlists(config.appId, customerId, wishlists);
        }
        this.variables = {
            // Web mode has no native handshake — we are ready as soon as the
            // provider mounts. The SDK's reducer reads this synchronously in its
            // initialize dispatch.
            isInitialized: true,
            customer: (_c = config.customer) !== null && _c !== void 0 ? _c : null,
            cart: null,
            product: null,
            device: { version: "web", platform: "web" },
            wishlists,
        };
    }
    setCustomer(customer) {
        this.variables = Object.assign(Object.assign({}, this.variables), { customer });
        this.events.emit("customer/updated", { customer });
        this.events.emit("variables/updated", this.variables);
    }
    setCart(cart) {
        this.variables = Object.assign(Object.assign({}, this.variables), { cart });
        this.events.emit("cart/updated", { cart });
        this.events.emit("variables/updated", this.variables);
    }
    setProduct(product) {
        this.variables = Object.assign(Object.assign({}, this.variables), { product });
        this.events.emit("product/updated", { product });
        this.events.emit("variables/updated", this.variables);
    }
    setWishlists(wishlists) {
        this.variables = Object.assign(Object.assign({}, this.variables), { wishlists });
        this.events.emit("variables/updated", this.variables);
    }
}
